import { useEffect, useState } from "react";
import api from "../../utils/axiosConfig";
import { getApiUrl, getRelativeUrl } from "../../utils/urlHelper";

const GroupCard = ({ group, onClick }) => {
  const [photoCount, setPhotoCount] = useState(0);

  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const isGlobalAdmin = currentUser?.role === "admin";
  const isGroupOwner =
    String(group?.createdBy?._id || group?.createdBy) === currentUser?._id;
  const isPermittedUser = group?.permittedUsers?.some(
    (u) => String(u._id || u) === currentUser?._id,
  );
  const showPhotoCount = isGlobalAdmin || isGroupOwner || isPermittedUser;

  useEffect(() => {
    if (!showPhotoCount) return;

    if (group.mediaCount !== undefined) {
      setPhotoCount(group.mediaCount);
      return;
    }

    const fetchGroupDetails = async () => {
      try {
        const res = await api.get(`/groups/${group._id}`);
        setPhotoCount(res.data.mediaCount ?? res.data.media?.length ?? 0);
      } catch (err) {
        console.error("Failed to fetch group detail", err);
      }
    };

    fetchGroupDetails();
  }, [group._id, group.mediaCount, showPhotoCount]);

  const coverUrl = group.coverImage
    ? getApiUrl(getRelativeUrl(group.coverImage))
    : null;
  const scale = group.coverPosition?.scale || 1;
  const posX = group.coverPosition?.posX ?? 50;
  const posY = group.coverPosition?.posY ?? 50;

  // Generate initials if no cover image
  const getInitials = (name) => {
    if (!name) return "G";
    const parts = name.trim().split(" ");
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  };

  return (
    <div
      className="group-card"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (onClick) onClick(e);
        }
      }}
    >
      <div
        className="group-thumbnail"
        style={{ overflow: "hidden", position: "relative" }}
      >
        {coverUrl ? (
          <img
            src={coverUrl}
            alt={group.name}
            loading="lazy"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: `${posX}% ${posY}%`,
              transform: `scale(${scale})`,
              transition: "transform 0.2s ease, object-position 0.2s ease",
            }}
          />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              background:
                "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #d946ef 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              fontSize: "32px",
              fontWeight: 800,
              letterSpacing: "1px",
              textShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }}
          >
            {getInitials(group.name)}
          </div>
        )}
      </div>

      <div className="group-info">
        <span className="group-title">
          {group.name}
          {group.privacy === "personal" && (
            <span className="lock-icon">🔒</span>
          )}
        </span>

        {showPhotoCount && (
          <span className="group-photos-count">{photoCount} Photos</span>
        )}
      </div>
    </div>
  );
};

export default GroupCard;
